(function () {
  var map = {
    "Starter Pack": "1 Belt",
    "His & Hers": "2 Belts",
    "Full Coverage": "3 Belts",
    "Her primary car": "For your main car",
    "Both cars covered": "For both cars",
    "All vehicles protected": "For every vehicle",
  };
  function rename() {
    var done = 0;
    document
      .querySelectorAll(
        ".kaching-bundles__bar-title, .kaching-bundles__bar-subtitle",
      )
      .forEach(function (el) {
        var t = el.textContent.trim();
        if (map[t]) {
          el.textContent = map[t];
          done++;
        }
      });
    return done;
  }
  var tries = 0;
  var iv = setInterval(function () {
    var n = rename();
    tries++;
    if (n >= 6 || tries > 150) clearInterval(iv);
  }, 200);
})();
